import React from 'react';
import PropTypes from 'prop-types';

export default function HardnessIcon({ size, color, ...rest }) {
  return (
    <svg width={size} height={size} viewBox="0 0 19 22" {...rest}>
      <path
        fill={color}
        d="M14.8865025,6.54225555 C15.0230118,6.54225555 15.1533162,6.60571099 15.2339808,6.71358523 L15.2339808,6.71358523 L18.1254965,10.6224401 C18.2433909,10.7874243 18.2433909,11.0095183 18.1192915,11.1681569 L18.1192915,11.1681569 L9.84186247,21.8350159 C9.76119787,21.9365446 9.63089352,22 9.50058916,22 C9.36407984,22 9.23998045,21.9365446 9.15931585,21.8286703 L9.15931585,21.8286703 L0.888091812,11.1681569 C0.763992426,11.0095183 0.763992426,10.7810787 0.881886842,10.6224401 L0.881886842,10.6224401 L3.77340252,6.71358523 C3.85406712,6.60571099 3.98437148,6.54225555 4.1208808,6.54225555 L4.1208808,6.54225555 Z M6.69594305,11.3585232 L2.1228807,11.3585232 L8.63189346,19.7536775 L6.69594305,11.3585232 Z M16.8782976,11.3648688 L12.3300552,11.3648688 L10.3692849,19.7536775 L16.8782976,11.3648688 Z M11.4365396,11.3648688 L7.58945863,11.3648688 L9.50058916,19.6584944 L11.4365396,11.3648688 Z M14.0674465,7.42428613 L4.99578147,7.42428613 L7.24198035,10.4701471 L11.7778129,10.4701471 L14.0674465,7.42428613 Z M4.1208808,7.73521777 L2.09806082,10.4701471 L6.14990575,10.4701471 L4.1208808,7.73521777 Z M14.9113224,7.77963657 L12.8760924,10.4701471 L16.9031175,10.4701471 L14.9113224,7.77963657 Z M0.614254728,2.37070211 L2.80363408,4.60968215 L2.18937935,5.2378529 L-6.34520214e-13,2.99887286 L0.614254728,2.37070211 Z M18.3857453,2.36643092 L19,2.99460167 L16.8106206,5.23358171 L16.1963659,4.60541096 L18.3857453,2.36643092 Z M9.93493701,0 L9.93493701,3.36313816 L9.06624131,3.36313816 L9.06624131,0 L9.93493701,0 Z"
      />
    </svg>
  );
}

HardnessIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

HardnessIcon.defaultProps = {
  size: 22,
  color: '#000',
};
